const RESTORE_AFTER_MS = 10_000;

export default function DoubleClickers() {
    const clickers = Array.from(document.querySelectorAll('.dont-double-click-me'))
        .map(el => new DoubleClicker(el));

    return { clickers };
}

const createSpinner = (type, size) => {
    const span = document.createElement('span');
    span.classList.add(`spinner-${type}`);
    if (size) span.classList.add(`spinner-${type}-${size}`);
    span.setAttribute('role', 'status');
    span.setAttribute('aria-hidden', 'true');
    return span;
};

class DoubleClicker {
    #clicked = false;
    #restoreCallbacks = [];

    constructor(el, restoreDelay = RESTORE_AFTER_MS) {
        console.log('Setting up DoubleClicker for %o', el)
        this.el = el;
        this.restoreDelay = restoreDelay;

        const handler = this.#handleClick.bind(this);

        if (el.form) {
            el.form.addEventListener('submit', handler);
        } else {
            el.addEventListener('click', handler);
        }
    }

    #handleClick(e) {
        if (this.#clicked) {
            e.preventDefault();
            return;
        }

        this.#clicked = true;
        this.#restoreCallbacks = [];

        const el = this.el;

        const addRestore = cb => this.#restoreCallbacks.unshift(cb);

        const addSpinnerAndDisable = () => {
            const spinner = createSpinner('grow', 'sm');
            if (el.children.length) {
                el.insertBefore(spinner, el.firstChild);
            } else {
                el.appendChild(spinner);
            }
            addRestore(() => spinner.remove());

            if (el.tagName === 'BUTTON') {
                el.disabled = true;
                addRestore(() => { el.disabled = false; });
            } else {
                el.classList.add('disabled');
                addRestore(() => el.classList.remove('disabled'));
            }
        };

        if (el.classList.contains('btn') || el.classList.contains('form-primary-cta')) {
            addSpinnerAndDisable();
        }

        setTimeout(() => this.#restore(), this.restoreDelay);
    }

    #restore() {
        for (const cb of this.#restoreCallbacks) {
            cb();
        }
        this.#clicked = false;
    }
}